import { getCategoryAndSubCategory } from "../../../../ga-utils";
import { getTemplateName } from "../../../../components/utils";

export function pushThreeColTwelveStoriesDataLayer({
  eventName = "dl_story_listing_component_click",
  link_position,
  section_name,
  pageType,
  windowLocation,
}) {
  const { category, subCategory, contentId } = getCategoryAndSubCategory(windowLocation, pageType, section_name);
  const template_name = getTemplateName(pageType);
  const platform = window.innerWidth >= 768 ? "desktop" : "mobile";
  if (typeof window !== "undefined" && window.dataLayer) {
    window.dataLayer = window.dataLayer || [];
    const data = {
      event: eventName,
      link_position,
      section_name: section_name?.toLowerCase(),
      category,
      sub_category: subCategory,
      content_id: contentId,
      template_name,
      platform,
    };
    window.dataLayer.push(data);
  }
}
